import {
  EXPERIMENT_DASHBOARD_TOKEN,
  useAppContext,
  useClientContext,
  useFormula,
  useNavigation,
} from "@data-root/react";
import {
  MenuItem as IMenuItem,
  ViewMenuItem as IViewMenuItem,
} from "@data-root/types";
import { Button, Collapse, Divider, Space } from "antd";
import { useCallback, useMemo } from "react";
import { DynamicIcon } from "./DynamicIcon";

const ViewMenuItem = ({ item }: { item: IViewMenuItem }) => {
  const { core } = useClientContext();
  const { appSpecifier, getView, styles, viewId } = useAppContext();
  const { navigation } = useNavigation();

  const getContext = useCallback(
    () => ({
      appId: appSpecifier.appId,
      deploymentId: appSpecifier.deploymentId,
    }),
    [appSpecifier.appId, appSpecifier.deploymentId]
  );

  const { value: show } = useFormula<boolean>(
    core,
    item.show,
    getContext,
    true
  );

  const view = useMemo(() => getView(item.viewId), [item.viewId, getView]);

  const onClick = useCallback(() => {
    navigation.navigate(item.viewId);
  }, [item.viewId, navigation]);

  if (!show) return null;

  return (
    <Button
      type="link"
      style={{
        color: item.viewId === viewId ? styles.primaryColor : "black",
      }}
      onClick={onClick}
      icon={<DynamicIcon type={view.icon} />}
    >
      {view.name}
    </Button>
  );
};

const render = (item: IMenuItem, i: number) =>
  item.type === "View" ? (
    <ViewMenuItem key={i} item={item} />
  ) : item.type === "Divider" ? null : (
    <Collapse
      key={i}
      bordered={false}
      style={{ backgroundColor: "transparent" }}
      items={[
        {
          key: "0",
          label: item.name,
          // children: <Menu key={i} menu={item.items} viewId={viewId} />,
          children: (
            <Space direction="vertical" style={{ width: "100%", padding: 10 }}>
              {item.items.map((item, i) => render(item, i))}
            </Space>
          ),
        },
      ]}
    />
  );

export const Menu = ({ menu }: { menu: IMenuItem[] }) => {
  const { navigation } = useNavigation();

  return (
    <Space direction="vertical" style={{ width: "100%", padding: 10 }}>
      {menu.map((item, i) => render(item, i))}
      {/* /*
      <Divider key="__divider__" />

       <Collapse
        key="__root__"
        bordered={false}
        style={{ backgroundColor: "transparent" }}
        items={[
          {
            key: "0",
            label: "Experiments",
            children: (
              <Space
                direction="vertical"
                style={{ width: "100%", padding: 10 }}
              >
                <Button
                  type="link"
                  style={{ color: "black" }}
                  onClick={() => {
                    navigation.navigate(EXPERIMENT_DASHBOARD_TOKEN);
                  }}
                  // icon={<DynamicIcon type={view.icon} />}
                >
                  Dashboard Analytics
                </Button>
              </Space>
            ),
          },
        ]} 
      /> */}
    </Space>
  );
};
